
import VueHorizontal from "vue-horizontal";

export default {
  components: { VueHorizontal },
  data() {
    return {
      left: 0,
      originX: 0,
      originLeft: 0,
      leftStatistics: 0,
      originXStatistics: 0,
      originLeftStatistics: 0,
      activeYear: null,
      activeImage: null,
      activeImageChange: false,
      distanceToTop: null,
      inViewport: true,
      years: [],
      animated: false,
      openedModal: false,
      options: [
        {
          name: "year",
          label: "Godina",
          type: "text",
        },
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },

        {
          name: "description",
          label: "Opis",
          type: "tipTap",
        },
        {
          name: "image",
          label: "Slika",
          type: "image",
        },
        {
          name: "video",
          label:
            "video (Ako zelite video oznacite kvadratic i otvorite modal te tamo dodajte video)",
          type: "checkbox",
        },
      ],
      optionsStatistics: [
        {
          name: "number",
          label: "Broj",
          type: "text",
        },
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
      ],
    };
  },
  watch: {
    activeImage(newValue) {
      if (newValue) {
        this.activeImageChange = true;
        setTimeout(() => {
          this.activeImageChange = false;
        }, 100);
      }
    },
  },
  mounted: function () {
    setTimeout(() => {
      this.getYears();
      this.setDefaultActiveImage();
      this.setDefaultActiveYear();
    }, 300);

    this.$nextTick(function () {
      this.setActiveYearOnScroll();
      this.isInViewport();
    });
    window.addEventListener("scroll", this.setActiveYearOnScroll, {
      passive: true,
    });
    window.addEventListener("scroll", this.isInViewport, { passive: true });
  },
  methods: {
    showModal(index) {
      this.openedModal = true;

      setTimeout(() => {
        this.setVideoAttributes();
      }, 300);
    },
    closeModal() {
      this.openedModal = false;
    },
    setVideoAttributes() {
      const el = document.getElementById("timeline");

      const video = el.getElementsByTagName("video");

      const attributes = {
        playsinline: "",
        preload: "auto",
        autoplay: "",
        loop: "",
      };

      if (video && video[0]) {
        video[0].addEventListener("suspend", () => {
          video[0].play();
        });

        video[0].playsinline = true;
        video[0].load();
        video[0].play();

        Object.keys(attributes).forEach((attr) => {
          video[0].setAttribute(attr, attributes[attr]);
        });
      }
    },
    getYears() {
      if (this.$refs.years && this.$refs.years.items) {
        this.years = this.$refs.years.items;
      }
    },
    setActiveYearOnScroll() {
      const years = document.getElementsByClassName("year");
      if (!years) return;

      years.forEach((year, index) => {
        const id = year.getAttribute("id");

        // mobile elements
        if (window.innerWidth < 640) {
          const windowHeightMobile = window.innerHeight / 2;
          const windowWidthMobile = window.innerWidth / 2;

          const middleElementsMobile = document.elementsFromPoint(
            windowWidthMobile,
            windowHeightMobile
          );
          middleElementsMobile.forEach((element) => {
            if (element && element.id && id && element.id === id) {
              this.activeYear = year;
              this.setActiveImage();
            }
          });
        } else {
          const windowHeight = window.innerHeight / 2;
          const windowWidth = window.innerWidth / 2;

          const middleElement = document.elementFromPoint(
            windowWidth,
            windowHeight
          );

          if (middleElement && middleElement.id && id) {
            if (middleElement.id === id) {
              this.activeYear = year;
              year.classList.add("active-year");
              this.setActiveImage();
            } else year.classList.remove("active-year");
          }
        }
      });
    },

    setActiveImage() {
      if (this.activeYear && this.activeYear.id) {
        const activeElement = document.getElementById(this.activeYear.id);

        if (activeElement) {
          const activeImg = activeElement.getElementsByTagName("img");
          if (
            activeImg[0] &&
            activeImg[0].__vue__ &&
            activeImg[0].__vue__.media &&
            activeImg[0].__vue__.media.path &&
            this.activeImage !== activeImg[0].__vue__.media.path
          ) {
            this.activeImage = activeImg[0].src;
          }
        }

        const calculatedDistance =
          activeElement.getBoundingClientRect().top - 100;

        this.distanceToTop = "-" + calculatedDistance + "px";
      }
    },
    setDefaultActiveImage() {
      if (!this.activeImage && this.$refs.years && this.$refs.years.items) {
        this.activeImage = this.$refs.years.items[0]?.image?.path;
      }
    },
    setDefaultActiveYear() {
      const years = document.getElementsByClassName("year");
      if (years) {
        this.activeYear = years[0];
      }
    },

    isInViewport() {
      var myElement = document.getElementById("yearsStart");

      if (!myElement) return;

      var bounding = myElement.getBoundingClientRect();
      var myElementHeight = myElement.offsetHeight;
      var myElementWidth = myElement.offsetWidth;

      if (!bounding || !myElementHeight || !myElementWidth) return;

      var bounding = myElement.getBoundingClientRect();
      if (
        bounding.top - 900 >= -myElementHeight &&
        bounding.left >= -myElementWidth &&
        bounding.right <=
          (window.innerWidth || document.documentElement.clientWidth) +
            myElementWidth &&
        bounding.bottom + 500 <=
          (window.innerHeight || document.documentElement.clientHeight) +
            myElementHeight
      ) {
        this.inViewport = true;
      } else {
        this.inViewport = false;
      }
    },

    // horizontal
    onScroll({ left }) {
      this.left = left;
    },
    onMouseDown(e) {
      this.originX = e.pageX;
      this.originLeft = this.left;

      window.addEventListener("mouseup", this.onMouseUp, { passive: true });
      window.addEventListener("mousemove", this.onMouseMove, { passive: true });
    },
    onMouseUp() {
      window.removeEventListener("mouseup", this.onMouseUp, { passive: true });
      window.removeEventListener("mousemove", this.onMouseMove, {
        passive: true,
      });
    },
    onMouseMove(e) {
      const offset = e.pageX - this.originX;
      const left = this.originLeft - offset;

      this.$refs.horizontal.scrollToLeft(left, "auto");
    },

    //horizontal statistics
    onScrollStatistics({ left }) {
      this.leftStatistics = left;
    },
    onMouseDownStatistics(e) {
      this.originXStatistics = e.pageX;
      this.originLeftStatistics = this.leftStatistics;

      window.addEventListener("mouseup", this.onMouseUpStatistics, {
        passive: true,
      });
      window.addEventListener("mousemove", this.onMouseMoveStatistics, {
        passive: true,
      });
    },
    onMouseUpStatistics() {
      window.removeEventListener("mouseup", this.onMouseUpStatistics, {
        passive: true,
      });
      window.removeEventListener("mousemove", this.onMouseMoveStatistics, {
        passive: true,
      });
    },
    onMouseMoveStatistics(e) {
      const offset = e.pageX - this.originX;
      const left = this.originLeftStatistics - offset;

      this.$refs.horizontalStatistics.scrollToLeft(left, "auto");
    },
  },
};
